var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "../../node_modules/tsup/assets/esm_shims.js"() {
  }
});

// ../../node_modules/lodash/noop.js
var require_noop = __commonJS({
  "../../node_modules/lodash/noop.js"(exports, module) {
    init_esm_shims();
    function noop2() {
    }
    module.exports = noop2;
  }
});

// src/v4/Carousel/index.ts
init_esm_shims();

// src/v4/Carousel/components/Carousel.tsx
init_esm_shims();
import { cx as cx4 } from "class-variance-authority";
import {
  Children as Children2,
  isValidElement,
  useRef as useRef3,
  useEffect as useEffect2,
  useState as useState2
} from "react";

// src/v4/Carousel/contexts/CarouselProvider.tsx
init_esm_shims();
var import_noop = __toESM(require_noop());
import { useReducedMotion } from "framer-motion";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";

// src/v4/Carousel/enums/CarouselTransitionType.ts
init_esm_shims();
var CarouselTransitionType = /* @__PURE__ */ ((CarouselTransitionType2) => {
  CarouselTransitionType2["Fade"] = "fade";
  CarouselTransitionType2["Slide"] = "slide";
  return CarouselTransitionType2;
})(CarouselTransitionType || {});

// src/v4/Carousel/contexts/CarouselProvider.tsx
import { jsx } from "react/jsx-runtime";
var DEFAULT_INTERVAL = 5;
var DEFAULT_TRANSITION_DURATION = 0.5;
var CarouselContext = createContext({
  activeIndex: 0,
  goToNextSlide: import_noop.default,
  goToPreviousSlide: import_noop.default,
  goToSlide: import_noop.default,
  infinite: false,
  interval: DEFAULT_INTERVAL,
  isAutoplaying: false,
  isResetting: false,
  shouldFade: false,
  shouldSlide: true,
  slideCount: 2,
  transitionDuration: DEFAULT_TRANSITION_DURATION,
  transitionType: "slide" /* Slide */,
  updateAutoplay: import_noop.default,
  virtualActiveIndex: 0
});
var useCarouselContext = () => {
  return useContext(CarouselContext);
};
function CarouselProvider({
  autoplay = false,
  children,
  infinite = false,
  interval = DEFAULT_INTERVAL,
  onActiveIndexChange = import_noop.default,
  slideCount,
  transitionDuration = DEFAULT_TRANSITION_DURATION,
  transitionType = "slide" /* Slide */
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [virtualActiveIndex, setVirtualActiveIndex] = useState(0);
  const [isAutoplaying, setIsAutoplaying] = useState(autoplay);
  const [isResetting, setIsResetting] = useState(false);
  const reduceMotion = useReducedMotion();
  const timeoutRef = useRef(null);
  const _transitionType = reduceMotion ? "fade" /* Fade */ : transitionType;
  const shouldFade = _transitionType === "fade" /* Fade */;
  const shouldSlide = _transitionType === "slide" /* Slide */;
  const goToNextSlide = useCallback(() => {
    setActiveIndex((currentIndex) => {
      const nextIndex = currentIndex === slideCount - 1 ? 0 : currentIndex + 1;
      if (infinite) {
        if (currentIndex === slideCount - 1) {
          setVirtualActiveIndex(slideCount);
        } else {
          setVirtualActiveIndex(nextIndex);
        }
      }
      return nextIndex;
    });
  }, [infinite, slideCount]);
  const goToPreviousSlide = useCallback(() => {
    setActiveIndex((currentIndex) => {
      const prevIndex = currentIndex === 0 ? slideCount - 1 : currentIndex - 1;
      if (infinite) {
        if (currentIndex === 0) {
          setVirtualActiveIndex(-1);
        } else {
          setVirtualActiveIndex(prevIndex);
        }
      }
      return prevIndex;
    });
  }, [infinite, slideCount]);
  const goToSlide = useCallback(
    (index) => {
      setActiveIndex(index);
      if (infinite) {
        setVirtualActiveIndex(index);
      }
    },
    [infinite]
  );
  const updateAutoplay = useCallback(
    (shouldAutoplay) => {
      setIsAutoplaying(autoplay && shouldAutoplay);
    },
    [autoplay]
  );
  useEffect(() => {
    const tick = () => {
      goToNextSlide();
      timeoutRef.current = setTimeout(tick, interval * 1e3);
    };
    if (isAutoplaying && interval) {
      timeoutRef.current = setTimeout(tick, interval * 1e3);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [goToNextSlide, interval, isAutoplaying]);
  useEffect(() => {
    if (isAutoplaying && interval) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        goToNextSlide();
      }, interval * 1e3);
    }
  }, [activeIndex, goToNextSlide, interval, isAutoplaying]);
  useEffect(() => {
    if (infinite && slideCount > 1) {
      if (virtualActiveIndex >= slideCount || virtualActiveIndex < 0) {
        const resetTimeout = setTimeout(() => {
          setIsResetting(true);
          setVirtualActiveIndex(activeIndex);
          setTimeout(() => {
            setIsResetting(false);
          }, 50);
        }, transitionDuration * 1e3);
        return () => {
          clearTimeout(resetTimeout);
        };
      }
    }
  }, [
    infinite,
    virtualActiveIndex,
    slideCount,
    activeIndex,
    transitionDuration
  ]);
  const values = useMemo(
    () => ({
      activeIndex,
      goToNextSlide,
      goToPreviousSlide,
      goToSlide,
      infinite,
      interval,
      isAutoplaying,
      isResetting,
      shouldFade,
      shouldSlide,
      slideCount,
      transitionDuration,
      transitionType: _transitionType,
      updateAutoplay,
      virtualActiveIndex
    }),
    [
      _transitionType,
      activeIndex,
      goToNextSlide,
      goToPreviousSlide,
      goToSlide,
      infinite,
      interval,
      isAutoplaying,
      isResetting,
      shouldFade,
      shouldSlide,
      slideCount,
      transitionDuration,
      updateAutoplay,
      virtualActiveIndex
    ]
  );
  useEffect(() => {
    onActiveIndexChange(activeIndex);
  }, [activeIndex, onActiveIndexChange]);
  return /* @__PURE__ */ jsx(CarouselContext.Provider, {
    value: values,
    children
  });
}
CarouselProvider.displayName = "CarouselProvider";

// src/v4/Carousel/components/CarouselLiveRegion.tsx
init_esm_shims();

// src/react-intl/FormattedMessage.tsx
init_esm_shims();
import { FormattedMessage as ReactIntlFormattedMessage } from "react-intl";

// src/react-intl/getLocaleFormatting.tsx
init_esm_shims();

// src/react-intl/htmlFormatting.tsx
init_esm_shims();

// src/v3/BodyLink/index.tsx
init_esm_shims();
import { forwardRef, useContext as useContext2 } from "react";
import { cx } from "class-variance-authority";

// src/contexts/ComponentProvider.tsx
init_esm_shims();
import { createContext as createContext2, useMemo as useMemo2 } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var GLOBAL_KEY = "__@jouzen/ecom-components:ComponentContext__";
function getOrCreateContext() {
  const g = globalThis;
  if (!g[GLOBAL_KEY])
    g[GLOBAL_KEY] = createContext2({});
  return g[GLOBAL_KEY];
}
var Context = getOrCreateContext();
function ComponentProvider({
  children,
  LinkComponent,
  ImageComponent
}) {
  const contextValue = useMemo2(
    () => ({ ImageComponent, LinkComponent }),
    [ImageComponent, LinkComponent]
  );
  return /* @__PURE__ */ jsx2(Context.Provider, {
    value: contextValue,
    children
  });
}
ComponentProvider.displayName = "ComponentProvider";

// src/v3/BodyLink/index.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var BodyLink = forwardRef(
  function BodyLink2({
    children,
    className,
    color = "sandstone-500",
    external = false,
    href = "",
    onClick,
    ...rest
  }, ref) {
    const context = useContext2(Context);
    const LinkComponent = external || !context.LinkComponent ? "a" : context.LinkComponent;
    return /* @__PURE__ */ jsx3(LinkComponent, {
      "data-cy": "body_link",
      ...rest,
      className: cx(`ui-underline ui-text-${color}`, className),
      href,
      onClick: (evt) => onClick == null ? void 0 : onClick(evt),
      ref,
      children
    });
  }
);
BodyLink.displayName = "BodyLink";

// src/react-intl/htmlFormatting.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var htmlFormatting = {
  br: /* @__PURE__ */ jsx4("br", {}),
  w: /* @__PURE__ */ jsx4("wbr", {}),
  r: String.fromCharCode(174),
  tm: String.fromCharCode(8482),
  break: function breakTag() {
    return /* @__PURE__ */ jsx4("br", {});
  },
  strong: function strong(chunks) {
    return /* @__PURE__ */ jsx4("strong", {
      children: chunks
    });
  },
  b: function b(chunks) {
    return /* @__PURE__ */ jsx4("strong", {
      children: chunks
    });
  },
  em: function em(chunks) {
    return /* @__PURE__ */ jsx4("em", {
      children: chunks
    });
  },
  i: function i(chunks) {
    return /* @__PURE__ */ jsx4("em", {
      children: chunks
    });
  },
  u: function u(chunks) {
    return /* @__PURE__ */ jsx4("span", {
      className: "ui-underline",
      children: chunks
    });
  },
  sup: function sup(chunks) {
    return /* @__PURE__ */ jsx4("sup", {
      className: "ui-font-serif ui-italic ui-text-blue-200 ui-font-semibold ui-tracking-wider",
      children: chunks
    });
  },
  li: function li(chunks) {
    return /* @__PURE__ */ jsx4("li", {
      children: chunks
    });
  },
  ExternalLink: function ExternalLink(href) {
    return /* @__PURE__ */ jsx4(BodyLink, {
      href,
      rel: "noreferrer",
      target: "_blank",
      children: href
    });
  },
  EmailLink: function EmailLink(email) {
    return /* @__PURE__ */ jsx4(BodyLink, {
      href: `mailto:${email}`,
      children: email
    });
  }
};

// src/react-intl/stringFormatting.ts
init_esm_shims();
var stringFormatting = Object.entries(
  htmlFormatting
).reduce((obj, [key, value]) => {
  const type = typeof value;
  if (type === "string") {
    return { ...obj, [key]: value };
  } else if (type === "function") {
    return { ...obj, [key]: (chunks) => chunks };
  }
  return { ...obj, [key]: "" };
}, {});

// src/react-intl/getLocaleFormatting.tsx
var getLocaleFormatting = (options = {}) => {
  const { stripHtml } = options;
  if (stripHtml) {
    return stringFormatting;
  }
  return htmlFormatting;
};
getLocaleFormatting.displayName = "getLocaleFormatting";
var getLocaleFormatting_default = getLocaleFormatting;

// src/react-intl/FormattedMessage.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
function FormattedMessage({
  id,
  values: optionalValues,
  ...props
}) {
  const localeFormatting = getLocaleFormatting_default();
  const values = {
    ...localeFormatting,
    ...optionalValues
  };
  return /* @__PURE__ */ jsx5(ReactIntlFormattedMessage, {
    id,
    values,
    ...props
  });
}
FormattedMessage.displayName = "FormattedMessage";
var FormattedMessage_default = FormattedMessage;

// src/v4/Carousel/components/CarouselLiveRegion.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
function CarouselLiveRegion() {
  const { activeIndex, slideCount } = useCarouselContext();
  if (slideCount > 1) {
    return /* @__PURE__ */ jsx6("div", {
      "aria-atomic": "true",
      "aria-live": "polite",
      className: "ui-sr-only",
      "data-cy": "carousel-live-region",
      children: /* @__PURE__ */ jsx6(FormattedMessage_default, {
        id: "carousel_live_region_text",
        values: {
          activeIndex: activeIndex + 1,
          slideCount
        }
      })
    });
  }
  return null;
}
CarouselLiveRegion.displayName = "CarouselLiveRegion";

// src/v4/Carousel/components/CarouselSlides.tsx
init_esm_shims();
import { cx as cx3 } from "class-variance-authority";
import { motion as motion2 } from "framer-motion";
import {
  Children,
  useRef as useRef2,
  useMemo as useMemo3
} from "react";

// src/v4/Carousel/components/CarouselSlide.tsx
init_esm_shims();
import { cx as cx2 } from "class-variance-authority";
import { motion } from "framer-motion";
import { jsx as jsx7 } from "react/jsx-runtime";
var useMotionProps = ({
  isActive
}) => {
  const { infinite, shouldFade, shouldSlide, slideCount, transitionDuration } = useCarouselContext();
  const totalSlides = infinite ? slideCount + 2 : slideCount;
  const output = {
    style: {
      width: shouldSlide ? `${1 / totalSlides * 100}%` : void 0
    }
  };
  if (shouldFade) {
    output.animate = { opacity: isActive ? 1 : 0 };
    output.initial = { opacity: isActive ? 1 : 0 };
    output.transition = {
      duration: transitionDuration,
      type: "tween"
    };
  }
  return output;
};
function CarouselSlide({
  children,
  isActive
}) {
  const { shouldFade, shouldSlide } = useCarouselContext();
  const motionProps = useMotionProps({ isActive });
  return /* @__PURE__ */ jsx7(motion.li, {
    "aria-hidden": !isActive,
    className: cx2(
      "ui-h-full ui-grid ui-grid-cols-1 ui-grid-rows-1 ui-pointer-events-none",
      {
        "ui-flex-none !ui-opacity-1": shouldSlide,
        "ui-absolute ui-inset-0 ui-w-full": shouldFade
      }
    ),
    "data-cy": "carousel-slide",
    ...motionProps,
    children
  });
}
CarouselSlide.displayName = "CarouselSlide";

// src/v4/Carousel/components/CarouselSlides.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var useMotionProps2 = () => {
  const {
    activeIndex,
    infinite,
    isResetting,
    shouldSlide,
    slideCount,
    transitionDuration,
    virtualActiveIndex
  } = useCarouselContext();
  const output = {};
  if (infinite) {
    const totalSlides = slideCount + 2;
    const position = virtualActiveIndex + 1;
    output.style = {
      width: `${totalSlides * 100}%`
    };
    if (shouldSlide) {
      const xPercentage = `-${position / totalSlides * 100}%`;
      output.animate = {
        x: xPercentage
      };
      output.initial = {
        x: xPercentage
      };
      output.transition = {
        duration: isResetting ? 0 : transitionDuration,
        type: "tween"
      };
    }
  } else {
    output.style = {
      width: `${slideCount * 100}%`
    };
    if (shouldSlide) {
      output.animate = {
        x: `-${activeIndex / slideCount * 100}%`
      };
      output.initial = {
        x: `-${activeIndex / slideCount * 100}%`
      };
      output.transition = {
        duration: transitionDuration,
        type: "tween"
      };
    }
  }
  return output;
};
function CarouselSlides({
  children,
  className
}) {
  const {
    activeIndex,
    goToNextSlide,
    goToPreviousSlide,
    infinite,
    shouldSlide
  } = useCarouselContext();
  const motionProps = useMotionProps2();
  const renderedSlides = useMemo3(() => {
    const slides = Children.toArray(children);
    if (infinite && slides.length > 1) {
      const result = [];
      result.push(
        /* @__PURE__ */ jsx8(CarouselSlide, {
          isActive: false,
          children: slides[slides.length - 1]
        }, "clone-last")
      );
      slides.forEach((child, i2) => {
        const key = `original-slide-${i2}`;
        result.push(
          /* @__PURE__ */ jsx8(CarouselSlide, {
            isActive: activeIndex === i2,
            children: child
          }, key)
        );
      });
      result.push(
        /* @__PURE__ */ jsx8(CarouselSlide, {
          isActive: false,
          children: slides[0]
        }, "clone-first")
      );
      return result;
    }
    return slides.map((child, i2) => {
      const key = `slide-${i2}`;
      return /* @__PURE__ */ jsx8(CarouselSlide, {
        isActive: activeIndex === i2,
        children: child
      }, key);
    });
  }, [children, infinite, activeIndex]);
  const isSwiping = useRef2(false);
  const swipeXStart = useRef2(0);
  const swipeXDistance = useRef2(0);
  const handleSwipeStart = (clientX) => {
    isSwiping.current = true;
    swipeXStart.current = clientX;
  };
  const handleSwipeMove = (clientX) => {
    if (isSwiping.current) {
      swipeXDistance.current = clientX - swipeXStart.current;
    }
  };
  const handleSwipeEnd = () => {
    if (Math.abs(swipeXDistance.current) >= 40) {
      if (swipeXDistance.current < 0) {
        goToNextSlide();
      } else {
        goToPreviousSlide();
      }
    }
    swipeXStart.current = 0;
    swipeXDistance.current = 0;
    isSwiping.current = false;
  };
  const onMouseDown = (event) => {
    handleSwipeStart(event.clientX);
  };
  const onMouseMove = (event) => {
    handleSwipeMove(event.clientX);
  };
  const onMouseUp = () => {
    handleSwipeEnd();
  };
  const onTouchStart = (event) => {
    handleSwipeStart(event.touches[0].clientX);
  };
  const onTouchMove = (event) => {
    handleSwipeMove(event.touches[0].clientX);
  };
  const onTouchEnd = () => {
    handleSwipeEnd();
  };
  return /* @__PURE__ */ jsx8("div", {
    className: cx3("ui-absolute ui-size-full ui-overflow-hidden", className),
    children: /* @__PURE__ */ jsx8(motion2.ul, {
      className: cx3("ui-h-full", {
        "ui-flex": shouldSlide
      }),
      "data-cy": "carousel-slides",
      onMouseDown,
      onMouseMove,
      onMouseUp,
      onTouchEnd,
      onTouchMove,
      onTouchStart,
      ...motionProps,
      children: renderedSlides
    })
  });
}
CarouselSlides.displayName = "CarouselSlides";

// src/v4/Carousel/components/Carousel.tsx
import { jsx as jsx9, jsxs } from "react/jsx-runtime";
var isCarouselSlides = (child) => {
  return isValidElement(child) && child.type === CarouselSlides;
};
function Carousel({
  autoplay,
  className,
  children,
  infinite,
  interval,
  onActiveIndexChange,
  resetSlides,
  transitionDuration,
  transitionType,
  ...props
}) {
  const slidesNode = Children2.toArray(children).find(isCarouselSlides);
  const slideCount = Children2.count(slidesNode == null ? void 0 : slidesNode.props.children);
  const prevResetSlidesRef = useRef3(resetSlides);
  const [resetKey, setResetKey] = useState2(0);
  useEffect2(() => {
    const prevResetSlides = prevResetSlidesRef.current;
    if (!prevResetSlides && resetSlides) {
      setResetKey((prev) => prev + 1);
    }
    prevResetSlidesRef.current = resetSlides;
  }, [resetSlides]);
  return /* @__PURE__ */ jsx9(CarouselProvider, {
    autoplay,
    infinite,
    interval,
    onActiveIndexChange,
    slideCount,
    transitionDuration,
    transitionType,
    children: /* @__PURE__ */ jsxs("div", {
      ...props,
      className: cx4("ui-relative", className),
      "data-cy": "carousel",
      children: [
        children,
        /* @__PURE__ */ jsx9(CarouselLiveRegion, {})
      ]
    })
  }, resetKey);
}
Carousel.displayName = "Carousel";

// src/v4/Carousel/components/CarouselNavDirection.tsx
init_esm_shims();
import { jsx as jsx10, jsxs as jsxs2 } from "react/jsx-runtime";
function CarouselNavDirection({
  children,
  direction,
  ...props
}) {
  const { goToNextSlide, goToPreviousSlide, updateAutoplay } = useCarouselContext();
  const onClick = () => {
    updateAutoplay(true);
    setTimeout(() => {
      if (direction === "forwards") {
        goToNextSlide();
      } else {
        goToPreviousSlide();
      }
    }, 50);
  };
  return /* @__PURE__ */ jsxs2("button", {
    "data-cy": "carousel-nav-direction",
    onClick,
    type: "button",
    ...props,
    children: [
      /* @__PURE__ */ jsx10("span", {
        className: "ui-sr-only",
        children: /* @__PURE__ */ jsx10(FormattedMessage_default, {
          id: "carousel_next_slide_label"
        })
      }),
      children
    ]
  });
}
CarouselNavDirection.displayName = "CarouselNavDirection";

// src/v4/Carousel/components/CarouselNavPagers.tsx
init_esm_shims();
import { cx as cx6 } from "class-variance-authority";

// src/v4/Carousel/components/CarouselNavPager.tsx
init_esm_shims();
import { jsx as jsx11, jsxs as jsxs3 } from "react/jsx-runtime";
function CarouselNavPager({
  children,
  index,
  ...props
}) {
  const { activeIndex, goToSlide, updateAutoplay } = useCarouselContext();
  const isActive = index === activeIndex;
  const onClick = () => {
    updateAutoplay(false);
    setTimeout(() => {
      goToSlide(index);
    }, 50);
  };
  return /* @__PURE__ */ jsxs3("button", {
    "data-cy": "carousel-nav-pager",
    onClick,
    type: "button",
    ...props,
    children: [
      /* @__PURE__ */ jsx11("span", {
        className: "ui-sr-only",
        children: /* @__PURE__ */ jsx11(FormattedMessage_default, {
          id: "carousel_page_dot_label",
          values: { index: index + 1 }
        })
      }),
      isActive ? /* @__PURE__ */ jsx11("span", {
        className: "ui-sr-only",
        children: /* @__PURE__ */ jsx11(FormattedMessage_default, {
          id: "carousel_current_slide_label"
        })
      }) : null,
      children
    ]
  });
}
CarouselNavPager.displayName = "CarouselNavPager";

// src/v4/Carousel/components/CarouselNavPagerDot.tsx
init_esm_shims();
import { cx as cx5 } from "class-variance-authority";
import { jsx as jsx12 } from "react/jsx-runtime";
function CarouselNavPagerDot({
  className,
  interval: _interval,
  isActive,
  isAutoplaying: _isAutoplaying,
  transitionDuration: _transitionDuration,
  ...props
}) {
  return /* @__PURE__ */ jsx12("span", {
    className: cx5(
      "ui-block ui-rounded-full ui-size-2",
      {
        "ui-bg-white": isActive,
        "ui-bg-slate-200": !isActive
      },
      className
    ),
    "data-cy": "carousel-nav-pager-dot",
    ...props
  });
}
CarouselNavPagerDot.displayName = "CarouselNavPagerDot";

// src/v4/Carousel/components/CarouselNavPagers.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
function CarouselNavPagers({
  className,
  CustomPagerDot,
  ...props
}) {
  const {
    activeIndex,
    interval,
    isAutoplaying,
    slideCount,
    transitionDuration
  } = useCarouselContext();
  const PagerDot = CustomPagerDot != null ? CustomPagerDot : CarouselNavPagerDot;
  return /* @__PURE__ */ jsx13("ul", {
    className: cx6("ui-flex ui-gap-x-2 ui-justify-center", className),
    "data-cy": "carousel-nav-pagers",
    ...props,
    children: Array(slideCount).fill(void 0).map((_, i2) => /* @__PURE__ */ jsx13("li", {
      className: "ui-leading-[0px]",
      children: /* @__PURE__ */ jsx13(CarouselNavPager, {
        index: i2,
        children: /* @__PURE__ */ jsx13(PagerDot, {
          interval,
          isActive: activeIndex === i2,
          isAutoplaying,
          transitionDuration
        })
      })
    }, `carousel-pager-item-${i2}`))
  });
}
CarouselNavPagers.displayName = "CarouselNavPagers";
export {
  Carousel,
  CarouselNavDirection,
  CarouselNavPagers,
  CarouselSlides,
  CarouselTransitionType,
  useCarouselContext
};
//# sourceMappingURL=index.mjs.map